export default "__VITE_ASSET__Cql$ZuVa__"